import { sigungu, dictSigungu} from "./vehicle_num.js";

export const avgChartData = [
    {
      name: "내 수익",
      월: 3000,
      fill: "#FF6600",
    },
    {
      name: "평균수익",
      월: 2500,
    },
    {
      name: "최대수익",
      월: 5000,
    },
  ];
  
export const rankData = [
      {
        name: "myRank",
        rank: 79,
        color:"#000000"
    
      },
    ];
  
export const pData = [
    {
      name: "0시",
      대: 460
    },
    {
      name: "1시",
      대: 370
    },
    {
      name: "2시",
      대: 290
    },
    {
      name: "3시",
      대: 90
    },
    {
      name: "4시",
      대: 270
    },
    {
      name: "5시",
      대: 610
    },
    {
      name: "6시",
      대: 1490
    },
    {
      name: "7시",
      대: 2570
    },
    {
      name: "8시",
      대: 2500
    },
    {
      name: "9시",
      대: 2400
    },
    {
      name: "10시",
      대: 2200
    },
    {
      name: "11시",
      대 : 1880
    },
    {
      name: "12시",
      대 : 1670
    },
    {
      name: "13시",
      대: 1600
    },
    {
      name: "14시",
      대 : 1520
    },
    {
      name: "15시",
      대: 1580
    },
    {
      name: "16시",
      대: 1850
    },
    {
      name: "17시",
      대: 2010
    },
    {
      name: "18시",
      대: 1970
    },
    {
      name: "19시",
      대: 1730
    },
    {
      name: "20시",
      대: 1650
    },
    {
      name: "21시",
      대: 1100
    },
    {
      name: "22시",
      대 : 900
    },
    {
      name: "23시",
      대: 740
    }
  ];
  
export const analyData = [
    {
      name: "Page A",
      uv: 300,
      pv: 300,
      amt: 300
    }
    
  ];

export const vehicleAllData = [
  {
    name: "종로구",
    관용 : 3697,
    자가용 : 44541,
    영업용 : 1688,
    소계 : 49926,
  },
  {
    name: "중구",
    관용 : 1224,
    자가용 : 45619,
    영업용 : 6051,
    소계 : 52894,
  },
  {
    name: "용산구",
    관용 : 335,
    자가용 : 77028,
    영업용 : 2084,
    소계 : 79447,
  },
  {
    name: "성동구",
    관용 : 345,
    자가용 : 93724,
    영업용 : 12482,
    소계 : 106551,
  },
  {
    name: "광진구",
    관용 : 297,
    자가용 : 92849,
    영업용 : 5448,
    소계 : 98594,
  },
  {
    name: "동대문구",
    관용 : 299,
    자가용 : 92930,
    영업용 : 4995,
    소계 : 98224,
  },
  {
    name: "중랑구",
    관용 : 250,
    자가용 : 104568,
    영업용 : 9453,
    소계 : 114271,
  },
  {
    name: "성북구",
    관용 : 293,
    자가용 : 115494,
    영업용 : 5198,
    소계 : 120985,
  },
  {
    name: "강북구",
    관용 : 317,
    자가용 : 71036,
    영업용 : 4247,
    소계 : 75600,
  },
  {
    name: "도봉구",
    관용 : 263,
    자가용 : 88001,
    영업용 : 7309,
    소계 : 95573,
  },
  {
    name: "노원구",
    관용 : 322,
    자가용 : 143259,
    영업용 : 9165,
    소계 : 152746,
  },
  {
    name: "은평구",
    관용 : 298,
    자가용 : 124620,
    영업용 : 7024,
    소계 : 131942,
  },
  {
    name: "서대문구",
    관용 : 456,
    자가용 : 83274,
    영업용 : 5802,
    소계 : 89532,
  },
  {
    name: "마포구",
    관용 : 339,
    자가용 : 112636,
    영업용 : 7009,
    소계 : 119984,
  },
  {
    name: "양천구",
    관용 : 315,
    자가용 : 142584,
    영업용 : 8605,
    소계 : 151504,
  },
  {
    name: "강서구",
    관용 : 336,
    자가용 : 185293,
    영업용 : 18776,
    소계 : 204405,
  },
  {
    name: "구로구",
    관용 : 298,
    자가용 : 132105,
    영업용 : 12308,
    소계 : 144711,
  },
  {
    name: "금천구",
    관용 : 139,
    자가용 : 82655,
    영업용 : 6289,
    소계 : 89083,
  },
  {
    name: "영등포구",
    관용 : 370,
    자가용 : 137152,
    영업용 : 9115,
    소계 : 146637,
  },
  {
    name: "동작구",
    관용 : 322,
    자가용 : 102756,
    영업용 : 2794,
    소계 : 105872,
  },
  {
    name: "관악구",
    관용 : 315,
    자가용 : 113094,
    영업용 : 5538,
    소계 : 118947,
  },
  {
    name: "서초구",
    관용 : 514,
    자가용 : 167156,
    영업용 : 10601,
    소계 : 178271,
  },
  {
    name: "강남구",
    관용 : 395,
    자가용 : 217129,
    영업용 : 18245,
    소계 : 235769,
  },
  {
    name: "송파구",
    관용 : 389,
    자가용 : 231943,
    영업용 : 13079,
    소계 : 245411,
  },
  {
    name: "강동구",
    관용 : 293,
    자가용 : 143117,
    영업용 : 8786,
    소계 : 152196,
  },
];

function rand(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export var feeGenerate = [];
var genWeekDayFee = rand(60,100) * 100;
feeGenerate.push(genWeekDayFee);
feeGenerate.push(Math.floor(genWeekDayFee*1.2));
feeGenerate.push(Math.floor(genWeekDayFee*2.5));
feeGenerate.push(Math.floor(genWeekDayFee*25));

var genTraffData = [];
genTraffData.push(rand(300,400));//0
genTraffData.push(rand(200,300));//1
genTraffData.push(rand(100,200));//2
genTraffData.push(rand(50,100));//3
genTraffData.push(rand(100,300));//4
genTraffData.push(rand(500,700));//5
genTraffData.push(rand(1300,1500));//6
genTraffData.push(rand(2500,3500));//7
genTraffData.push(rand(2000,2500));//8
genTraffData.push(rand(2000,2500));//9
genTraffData.push(rand(2000,2500));//10
genTraffData.push(rand(1500,2000));//11
genTraffData.push(rand(1300,1700));//12
genTraffData.push(rand(1300,1700));//13
genTraffData.push(rand(1300,1700));//14
genTraffData.push(rand(1300,1700));//15
genTraffData.push(rand(1700,2000));//16
genTraffData.push(rand(1900,2200));//17
genTraffData.push(rand(2000,2500));//18
genTraffData.push(rand(2000,2500));//19
genTraffData.push(rand(1000,1400));//20
genTraffData.push(rand(1000,1200));//21
genTraffData.push(rand(700,900));//22
genTraffData.push(rand(400,600));//23
pData.forEach((val,idx)=>val.대 = genTraffData[idx]);